import {FC} from 'react'
import Card from '_core/components/Card'
import {useDispatch} from 'react-redux'
import ShippingPackageList from './ShippingPackageList'

import AddPackageButton from './AddPackageButton'
import clsx from 'clsx'
import {ErrorMessage} from '_core'

type Props = {
  totalWeight: number
  onTotalWeightChange: (weight: number) => void
  onChange: (shippingPackage: any) => void
  shippingPackage: any
}
const ShippingPackages: FC<Props> = ({
  totalWeight,
  shippingPackage,
  onTotalWeightChange,
  onChange,
}) => {
  const dispatch = useDispatch()

  const handleTotalWeightChange = (e: any) => {
    const {value} = e.target

    dispatch(onTotalWeightChange(value))
  }

  return (
    <Card
      className='card card-xl-stretch mb-5 mb-xl-8 pb-10'
      title='Choose package type'
      toolbar={<AddPackageButton />}
    >
      <ShippingPackageList shippingPackage={shippingPackage} onChange={onChange} />
      <div className='separator my-5 mx-n10'></div>
      <div className='fv-row fv-plugins-icon-container'>
        <label className='required form-label'>Total weight (with package)</label>
        <div className='d-flex justify-content-between align-items-center'>
          <input
            className={clsx('form-control', totalWeight === 0 && 'is-invalid')}
            onChange={handleTotalWeightChange}
            value={totalWeight}
            type='number'
            title='totalWeight'
            min={0.1}
          />
          <span className='text-muted mx-5'>lbs</span>
        </div>
      </div>
      {totalWeight === 0 && (
        <ErrorMessage error='No package weight entered. Package weight must be greater than 0 lbs' />
      )}
      {150 < totalWeight && <ErrorMessage error='Package weight must be less than 150 lbs' />}
    </Card>
  )
}

export default ShippingPackages
